import React from "react";

export interface SelectOption {
    label: string;
    value: string | number;
}

interface SelectProps {
    label?: string;
    selectedValue: string | number;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    options: SelectOption[];
}

export const Select = ({
    label,
    selectedValue,
    onChange,
    options,
}: SelectProps) => {
    return (
        <div>
            {label && (
                <label className="block text-sm font-medium mb-1">
                    {label}
                </label>
            )}
            <select
                value={selectedValue}
                onChange={onChange}
                className="w-full border rounded px-2 py-1"
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
